import { $admin } from "@/utils/https";

// 企业微信登录
export function authenticateEwx(code) {
    return $admin().post(`/api/admin/manage/account/ewx/login`, {
        code,
    });
}

// 企业微信内使用自动登录
export function authenticateEwxAutoLogin(code) {
    return $admin().post(`/api/admin/account/ewx/oauth/callback`, {
        code,
    });
}

// 通过手机号获取企业微信id
export function syncEwx(phone) {
    return $admin().get(`/api/admin/manage/account/ewx/sync`, {
        params: { phone },
    });
}

// 账密登录
export function authenticatePassword(credentials) {
    return $admin().post(`/api/admin/manage/account/admin/login`, credentials);
}

// 登出
export function logout() {
    return $admin().post(`/api/admin/manage/account/admin/logout`);
}

/**
 * 查询账号是否可用
 * @param {Object} params 参数
 * @param {String} params.username 用户名
 * @param {String} [params.id] 邮箱
 */
export function checkUsername(params) {
    return $admin().get(`/api/admin/manage/account/admin/check`, {
        params,
    });
}

/**
 * 创建管理员账号
 * @param {Object} data 参数
 */
export function createAccount(data) {
    return $admin().post(`/api/admin/manage/account/admin`, data);
}

/**
 * 获取管理员账号列表
 * @param {Object} params 参数
 */
export function getAccountList(data) {
    const params = {
        status: 1,
        ...data,
    };
    return $admin().get(`/api/admin/manage/account/admin`, {
        params,
    });
}

/**
 * 删除管理员账号
 * @param {string} id 账号id
 */
export function deleteAccount(id) {
    return $admin().delete(`/api/admin/manage/account/admin/${id}`);
}

/**
 * 获取管理员账号详情
 * @param {string} id 账号id
 */
export function getAccountDetail(id) {
    return $admin().get(`/api/admin/manage/account/admin/${id}`);
}

/**
 * 更新管理员账号
 * @param {string} id 账号id
 * @param {Object} data 参数
 */
export function updateAccount(id, data) {
    return $admin().put(`/api/admin/manage/account/admin/${id}/profile`, data);
}

/**
 * 更新管理员账号密码
 * @param {string} id 账号id
 * @param {Object} data 参数
 */
export function updateAccountPassword(id, data) {
    return $admin().put(`/api/admin/manage/account/admin/${id}/password`, data);
}

/**
 * 修改密码
 * @param {Object} data 参数
 */
export function updatePassword(data) {
    return $admin().put(`/api/admin/manage/account/admin/i/password`, data);
}

/**
 * 更新角色权限
 * @param {string} id 账号id
 * @param {Object} data 参数
 */
export function updateAccountRole(id, data) {
    console.log(data);
    return $admin().put(`/api/admin/manage/account/admin/${id}/group`, data);
}

// 获取我的身份和权限
export function getMyPermission() {
    return $admin().get(`/api/admin/account/permission/i`);
}

export function updateMyProfile(data) {
    return $admin().put(`/api/admin/manage/account/admin/profile/i`, data);
}
